<template>
  <v-content>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="title"
            :headers="headers"
            :items="groups"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteGroup"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addGroup">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_GROUPS,
  DELETE_GROUP,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Users",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_GROUPS, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Groups",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      groupid: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog")
  },
  computed: {
    ...mapGetters(["groups",'currentUser']),
    headers () {
      return [
        { text: this.$t("Group id"), value: "group_id" },  
        { text: this.$t("Name"), value: "group_name" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    }
  },
  created (){
    if(this.currentUser.roles.includes(1) == false){
      this.$router.push('/learningcenter');
    }
  },
  methods: {
    addGroup() {
      this.$router.push("/groups/add");
    },
    editing(id) {
      this.$router.push("/groups/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.groupid = id
    },
    async deleteGroup() {
      await this.$store
        .dispatch(DELETE_GROUP, this.groupid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.groupid = null;
            await store.dispatch(FETCH_GROUPS, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>